import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../core/services/auth.service';
import { WgisService } from '../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { WMAIApiService } from '../core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
})
export class ResetpasswordComponent implements OnInit {

  isSubmitting = false;
  paramsSubscription: any;
  id: number;
  uuid: string;
  email: string;
  passwordVisible = false;
  emailVisible = true;
  resetPasswordError = false;
  resetPasswordSuccess = false;

  constructor(
    private auth: AuthService,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private wmaiservice: WMAIApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.wgisservice.setMapInvisible();
    this.resetView();
  }

  ngOnInit() {
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.id = param['id'];
      this.uuid = param['uuid'];
      this.email = param['email'];
      if (this.id !== undefined && this.uuid !== undefined && this.email !== undefined) {
        this.passwordVisible = true;
        this.emailVisible = false;
      }
    });
  }

  /** si invia il modulo contente l'indirizzo email del richiedente
   * @param  {form.value.email} value
   */
  submit(form: NgForm) {
    if (!form.valid) {
      return false;
    }

    this.wmaiservice.sendResetPassword(form.value.email).subscribe(
      (data) => {
        this.resetPasswordSuccess = Array.isArray(data) && data.length > 0 ? true : false;
        this.resetPasswordError = Array.isArray(data) && data.length === 0 ? true : false;
      }
    );
  }

  /** si invia il modulo contente l'indirizzo email del richiedente
   * @param  {form} value
   */
  submitPassword(form: NgForm) {
    if (!form.valid) {
      return false;
    }

    if (this.email != null && this.uuid != null && this.id != null) {
      this.auth.resetPassword(this.email, form.value.password).subscribe(
        (data) => {
          this.resetPasswordSuccess = Array.isArray(data) && data.length > 0 ? true : false;
          this.resetPasswordError = Array.isArray(data) && data.length === 0 ? true : false;
          if (this.resetPasswordSuccess) {
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          }
        }
      );
    }
  }

  resetView() {
    this.emailVisible = true;
    this.passwordVisible = false;
  }

}
